import React, { useEffect, useRef, useState } from "react";

import { toast } from "react-toastify";
import Modal from "../../components/Modal";
import Fileupload from "../../components/Fileupload";
import LoadingScreen from "react-loading-screen";
import {
  fileDelete,
  get_prev_files,
  getdownload,
  sendAutoTagPdf,
} from "../../api/api";

const AutoTagPdf = () => {
  const [selectedData, setSelectedData] = useState({});
  const [loading, setLoading] = useState(false);
  const isDownloadRef = useRef([]);

  const [isSubmitted, setIsSubmitted] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [fileToDelete, setFileToDelete] = useState();
  const [prevfiles, setPrevFiles] = useState([]);
  const [emptyFiles, setEmptyFiles] = useState(0);
  const [, forceUpdate] = useState(0);
  let category = "9";

  useEffect(() => {
    fetchprevfile("autotag_pdf");
  }, []);

  const toggleDownload = (fileid) => {

    if (isDownloadRef.current.includes(fileid)) {
      isDownloadRef.current = isDownloadRef.current.filter(
        (id) => id !== fileid
      );
    } else {
      isDownloadRef.current.push(fileid);
    }
    forceUpdate((prev) => prev + 1);
  };

  const handleSubmit = async () => {
    if (!selectedData.filename) {
      toast.warn("Please choose file");
      return;
    }
    setIsSubmitted(true);
    setLoading(true);
    try {
      const result = await sendAutoTagPdf(selectedData);

      if (result.data) {
        downloadreport(result.data.content, result.data.filename, null);
        toast.success("The file process completed.");
        fetchprevfile("autotag_pdf");
        setEmptyFiles(1);
      } else if (result.error) {
        toast.warn(result.error.message);
        setEmptyFiles(1);
      }
    } catch (e) {
      toast.error(e.message || "An error occurred");
    } finally {
      setIsSubmitted(false);
      setLoading(false);
    }
  };

  const fetchprevfile = async (process) => {
    try {
      let data = await get_prev_files(process);
      if (data.data) {
        setPrevFiles(data.data);
      } else {
        // alert(data.error);
        toast.error(data.error.message);
      }
    } catch (e) {
      // alert(e);
      toast.error(e);
    }
  };

  const handleDownload = async (fileid, process) => {
    try {
      toggleDownload(fileid);

      let data = await getdownload(fileid, process);
      if (data.data) {
        downloadreport(data.data.content, data.data.file_name, fileid);
      } else if (data.error && typeof data.error === "object") {
        const firstMessage = Object.values(data.error)[0];
        toggleDownload(fileid);
        toast.error(firstMessage);
      }
    } catch (e) {
      toast.error(e);
    }
  };

  const handleFileDelete = async (fileid, filename) => {
    setShowModal(true);
    setFileToDelete({ fileid: fileid, filename: filename });
  };

  const downloadreport = (data, filename, fileid) => {
    try {
      const file = data;
      const byteCharacters = atob(file);
      const byteArrays = [];

      for (let offset = 0; offset < byteCharacters.length; offset += 1024) {
        const slice = byteCharacters.slice(offset, offset + 1024);
        const byteNumbers = new Array(slice.length);
        for (let i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
        }
        byteArrays.push(new Uint8Array(byteNumbers));
      }
      // console.log(byteArrays);
      const blob = new Blob(byteArrays, { type: "application/zip" });
      const url = window.URL.createObjectURL(blob);
      downloadfile(url, filename, fileid);
    } catch (e) {
      console.log(e);
    }
  };

  const downloadfile = (url, filename, fileid) => {
    if (url) {
      const link = document.createElement("a");
      link.href = url;
      link.download = `${filename}`; // You can specify the name of the file here
      link.click();
      // Clean up the URL object
      window.URL.revokeObjectURL(url);
      // toast.success("File download started")
      if (fileid) {
        toggleDownload(fileid);
      }
    } else {
      // alert("No File to Download");
      toast.info("No Files to Download");
    }
  };

  const confirmFileDelete = async () => {
    if (fileToDelete) {
      let response = await fileDelete(
        fileToDelete.fileid,
        "autotag_pdf"
      );

      if (response.data) {
        toast.success(response.data.message);

        fetchprevfile("autotag_pdf");
      } else {
        // alert(response.error.message);
        toast.error(response.error.message);
      }
    }
  };

  return (
    <LoadingScreen
      loading={loading}
      bgColor="#f1f1f1"
      spinnerColor="#1A53A9"
      textColor="#1A53A9"
      text="Processing file please wait ...."
    >
      <div className="h-full w-full flex flex-col">
        <div className="p-8 flex flex-col gap-8 h-[100%]">
          <Fileupload
            key={emptyFiles}
            // file={files}
            // setFiles={setFiles}
            setSelectedData={setSelectedData}
            emptyfile={emptyFiles}
            category={category}
          />
          <div className="w-full text-right flex gap-4 justify-end mt-10 mb-10">
            {/* <button
              className="py-2 px-5 border-[1px] rounded-lg border-commonborder text-btntext"
              onClick={() => confirmFileDelete()}
            >
              cancel
            </button> */}
            <button
              className="py-2 px-5 bg-highlighttext rounded-lg text-white"
              type="submit"
              onClick={() => handleSubmit()}
              disabled={isSubmitted}
            >
              {isSubmitted ? "Processing" : "Submit"}
            </button>
          </div>

          <div className="w-full">
            {prevfiles?.length > 0 && (
              <div className="">
                <div className="w-full flex justify-start">
                  <h1 className="text-24 font-semibold">Previous Files</h1>
                </div>
                <div className=" rounded-[16px] border-[1px] border-commonborder shadow-commonshadow mt-10 overflow-auto max-h-[600px]">
                  <table className="w-full">
                    <thead className="sticky top-0 z-10 bg-tableheadingbg px-4 py-6 text-left text-white text-16 font-semibold w-full">
                      <tr>
                        <th className="px-4 py-5">S.No</th>
                        <th className="px-4 py-5">File Name</th>
                        <th className="px-4 py-5">File Uploaded on</th>
                        <th className="px-4 py-5">Download Report</th>
                        <th className="px-4 py-5">Status</th>
                        <th className="px-4 py-5">Delete</th>
                      </tr>
                    </thead>
                    <tbody className="w-full text-left bg-white">
                      {prevfiles.map((files, i) => (
                        <tr
                          key={i}
                          className="border-b-[1px] border-commonborder last:border-none"
                        >
                          <td className="px-4 py-5">{i + 1}</td>
                          <td className="px-4 py-5">{files.file_name}</td>
                          <td className="px-4 py-5">{files.date}</td>
                          <td className="px-4 py-5">
                            <button
                              className=""
                              disabled={
                                files.file_status === "0" ||
                                files.file_status === "2" ||
                                isDownloadRef.current.includes(files.file_id)
                              }
                              onClick={() => {
                                if (
                                  !isDownloadRef.current.includes(files.file_id)
                                ) {
                                  handleDownload(
                                    files.file_id,
                                    "autotag_pdf"
                                  );
                                }
                              }}
                            >
                              <p
                                className={`${
                                  files.file_status === "1"
                                    ? "text-highlight"
                                    : "text-gray opacity-[70%]"
                                }`}
                              >
                                {isDownloadRef.current.includes(files.file_id)
                                  ? "Downloading..."
                                  : "Download"}
                              </p>
                            </button>
                          </td>
                          <td className="px-4 py-5">
                            <div
                              className={`w-fit px-4 py-1 rounded-[12px] text-white font-regular ${
                                files.file_status === "0"
                                  ? "bg-highlight"
                                  : files.file_status === "1"
                                  ? "bg-[#008000]"
                                  : "bg-[#f89611]"
                              }`}
                            >
                              {files.file_status === "0" ? (
                                <button className="py-1">
                                  {`Resume ${files.resume_process}`}
                                </button>
                              ) : files.file_status === "1" ? (
                                <div className="py-1">Completed</div>
                              ) : (
                                <div className="py-1">Processing...</div>
                              )}
                            </div>
                          </td>
                          <td className="px-4 py-5">
                            <button
                              onClick={() =>
                                handleFileDelete(files.file_id, files.file_name)
                              }
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="red"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                class="icon icon-tabler icons-tabler-outline icon-tabler-trash"
                              >
                                <path
                                  stroke="none"
                                  d="M0 0h24v24H0z"
                                  fill="none"
                                />
                                <path d="M4 7l16 0" />
                                <path d="M10 11l0 6" />
                                <path d="M14 11l0 6" />
                                <path d="M5 7l1 12a2 2 0 0 0 2 2h8a2 2 0 0 0 2 -2l1 -12" />
                                <path d="M9 7v-3a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v3" />
                              </svg>
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            )}
          </div>
          {showModal && (
            <div>
              <Modal
                title={"Alert"}
                body={`Do you wish to delete file ${fileToDelete?.filename} ?`}
                setShow={setShowModal}
                setConfirm={confirmFileDelete}
                confirmbtn={"Confirm"}
                cancelbtn={"Cancel"}
              />
            </div>
          )}
        </div>
      </div>
    </LoadingScreen>
  );
};

export default AutoTagPdf;
